import { PortableText } from "@portabletext/react";
import React from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";

import Link from "../link";
import ListItem from "../../components/listItem";

import { baseColor2 } from "../../styles/color";
import { breakpointMd } from "../../styles/layout";

import { getColorArray } from "../../utl/format";

const blockquoteColors = getColorArray(4);

const blockquoteStyle = () => {
  let styles = {};
  let style = undefined;
  for (let i = 0; i < blockquoteColors.length; i++) {
    style = css`
      background-color: ${blockquoteColors[i]};
    `;
    styles[`span:nth-of-type(${i + 1})`] = style;
  }
  return styles;
};

const H1 = styled.h1`
  font-size: 2.5rem;

  @media only screen and (min-width: ${breakpointMd}) {
    font-size: 3.25rem;
  }
`;

const H2 = styled.h2`
  margin-bottom: 1rem;
  font-size: 2.25rem;
`;

const H3 = styled.h3`
  margin-bottom: 1rem;
  font-size: 2rem;
`;

const H4 = styled.h4`
  margin-bottom: 1rem;
  font-size: 1.75rem;
`;

const ulStyles = css`
  margin-left: 1.8rem;
  font-size: 1.2rem;

  li {
    margin-bottom: 0.5rem;
    line-height: 1.6;
  }

  li:last-of-type {
    margin-bottom: 1rem;
  }
`;

const olStyles = css`
  font-size: 1.2rem;

  li {
    margin-bottom: 0.5rem;
    line-height: 1.6;
  }

  li:last-of-type {
    margin-bottom: 1rem;
  }
`;

const Blockquote = styled.div`
  display: grid;
  grid-template-areas: color-bar quote;
  grid-template-columns: 8px auto;
  grid-column-gap: 1rem;
  margin: 2rem 0;
  color: ${baseColor2};

  div:first-of-type {
    display: grid;
    grid-template-rows: repeat(4, auto);

    ${blockquoteStyle}
    span:nth-of-type(1) {
      border-radius: 2px 2px 0 0;
    }

    span:nth-of-type(4) {
      border-radius: 0 0 2px 2px;
    }
  }

  div:last-of-type {
    margin: 0.5rem 0;
    font-size: 1.4rem;
    font-weight: 500;
  }
`;

const P = styled.p`
  color: ${baseColor2};
  margin: 0 0 1rem 0;
`;

const serializers = {
  container: React.Fragment,
  types: {
    vimeo: (props) => {
      return (
        <>
          <div
            style={{
              padding: "56.25% 0 0 0",
              marginBottom: "1rem",
              position: "relative",
            }}
          >
            <iframe
              src={props.value.url}
              title={props.value.title}
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
              }}
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
          <script src="https://player.vimeo.com/api/player.js"></script>
        </>
      );
    },
  },
  block: (props) => {
    switch (props.node.style) {
      case "h1":
        return <H1>{props.children}</H1>;

      case "h2":
        return <H2>{props.children}</H2>;

      case "h3":
        return <H3>{props.children}</H3>;

      case "h4":
        return <H4>{props.children}</H4>;

      case "blockquote":
        return (
          <Blockquote>
            <div>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
            <div>{props.children}</div>
          </Blockquote>
        );

      default:
        // Check for empty lines and eliminate them
        if (props.children[0] === "") {
          return "";
        } else {
          return <P>{props.children}</P>;
        }
    }
  },
  // lists are serialized separately from types
  list: (props) => {
    if (props.value.listItem === "bullet") {
      return <ul css={ulStyles}>{props.children}</ul>;
    }
    return <ol css={olStyles}>{props.children}</ol>;
  },
  listItem: (props) => <ListItem>{props.children}</ListItem>,
  marks: {
    link: (props) => {
      return (
        <Link to={props.value.href} external>
          {props.text}
        </Link>
      );
    },
  },
};

const BlockContent = ({ blocks }) => (
  <PortableText value={blocks} components={serializers} />
);

export default BlockContent;
